export default __webpack_public_path__ + "static/media/play.dbcd922e.png";